import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
export var wrapper = {
  mb: 3,
  display: 'flex',
  alignItems: 'center'
};

if (typeof wrapper !== 'undefined' && wrapper && wrapper === Object(wrapper) && Object.isExtensible(wrapper) && !wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/NavSearch/styles.js"
    }
  });
}

export var input = {
  outline: 'none',
  background: 'none',
  border: 'none',
  color: 'text',
  fontSize: 1
};

if (typeof input !== 'undefined' && input && input === Object(input) && Object.isExtensible(input) && !input.hasOwnProperty('__filemeta')) {
  Object.defineProperty(input, '__filemeta', {
    configurable: true,
    value: {
      name: "input",
      filename: "node_modules/gatsby-theme-docz/src/components/NavSearch/styles.js"
    }
  });
}

export var icon = {
  color: 'border',
  mr: 2
};

if (typeof icon !== 'undefined' && icon && icon === Object(icon) && Object.isExtensible(icon) && !icon.hasOwnProperty('__filemeta')) {
  Object.defineProperty(icon, '__filemeta', {
    configurable: true,
    value: {
      name: "icon",
      filename: "node_modules/gatsby-theme-docz/src/components/NavSearch/styles.js"
    }
  });
}